import { createFeatureSelector, createSelector } from '@ngrx/store';
import { IPerformanceDataInception, PerformanceSettings } from 'src/app/models/performance';
import { PerformanceState } from '../../state/performance.state';

export const selectPerformanceState =
  createFeatureSelector<PerformanceState>('performance');

export const selectPerformanceData = createSelector(
  selectPerformanceState,
  state => state.performanceData
);

export const selectperformanceDataAndSettings = createSelector(
  selectPerformanceState,
  state => {
    return {
      performanceData: state.performanceData,
      settings: state.settings,
      loading: state.loading,
      retrieveData: state.retrieveData,
    };
  }
);

export const selectPerformanceDataErrorLoading = createSelector(
  selectPerformanceState,
  state => {
    return {
      performanceData: state.performanceData,
      loading: state.loading,
      error: state.error,
    };
  }
);


export const selectPerformanceSettings = createSelector(
  selectPerformanceState,
  state => {
    return {
      selectedReturnSpanMonths: state.settings.selectedReturnSpanMonths,
      selectedReturnPeriod: state.settings.selectedReturnPeriod,
      selectedReturnType: state.settings.selectedReturnType,
      selectedReturnSymbol: state.settings.selectedReturnSymbol
    } as PerformanceSettings;
  }
);

export const selectPerformanceDataCurrency = createSelector(
  selectPerformanceData,
  state => state.currency
);

export const selectePerformanceClosingValue = createSelector(
  selectPerformanceState,
  state => state.performanceData.closingValue
);

export const selectPerformanceStateLoading = createSelector(
  selectPerformanceState,
  state => state.loading
);

export const selectePerformanceInceptionDates = createSelector(
  selectPerformanceState,
  (state: PerformanceState) : {
    glInception ?: Date,
    historicInception ?: Date,
    overrideInception : boolean
  } => {
    return {
      glInception: state.performanceData.glInception,
      historicInception: state.performanceData.historicInception,
      overrideInception: state.performanceData.overrideInception
    } as IPerformanceDataInception 
  }
)